// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/CustomerFeedbackChart.js
//
// Purpose:
// Customer Feedback Distribution
//
// Positive
// Neutral
// Negative
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

const COLORS = [
  "#10b981",
  "#f59e0b",
  "#ef4444",
];

export default function CustomerFeedbackChart({

  data = [],

  onFeedbackClick,

}) {

  return (

    <DashboardCard

      title="Customer Feedback"

      subtitle="Positive / Neutral / Negative"

      height={450}

    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <PieChart>

          <Pie
            data={data}
            dataKey="count"
            nameKey="label"
            innerRadius={70}
            outerRadius={120}
            paddingAngle={3}
            onClick={(row) =>
              onFeedbackClick &&
              onFeedbackClick(
                row.label
              )
            }
          >

            {data.map(
              (entry, index) => (

                <Cell
                  key={index}
                  fill={
                    COLORS[
                      index %
                      COLORS.length
                    ]
                  }
                />

              )
            )}

          </Pie>

          <Tooltip />

          <Legend />

        </PieChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}